import React, { useState, useRef } from "react";
import "./contentpage.css";
import Question from "../components/Question";
import LandingSection from "./LandingSection";
import FloatingPageNav from "../components/FloatingPageNav";
function BitcoinTechPage78() {
  const run_bitcoin_regtest = String.raw`
#!/bin/bash
set -e

VERSION="29.2.knots20251110"
BASE_URL="https://bitcoinknots.org/files/29.x/\$'{'VERSION'}'"
ARCHIVE="bitcoin-\$'{'VERSION'}'-x86_64-linux-gnu.tar.gz"
BITCOIN_DIR="\$HOME/bitcoin-knots"
DATA_DIR="\$HOME/tmp/regtest_bitcoin"
OUT_FILE="out.txt"

echo "[*] Preparing environment..."
sudo apt-get update -y >/dev/null 2>&1
sudo apt-get install -y wget gpg jq bc >/dev/null 2>&1
mkdir -p "\$BITCOIN_DIR" "\$DATA_DIR"
cd "\$BITCOIN_DIR"

echo "[*] Downloading Bitcoin Knots binaries and signatures..."
wget -q "\${BASE_URL}/\${ARCHIVE}" -O "\$ARCHIVE"
wget -q "\${BASE_URL}/SHA256SUMS"
wget -q "\${BASE_URL}/SHA256SUMS.asc"

echo "[*] Importing recommended signing keys..."
gpg --keyserver hkps://keys.openpgp.org --recv-keys \
  1A3E761F19D2CC7785C5502EA291A2C45D0C504A \
  DAED928C727D3E613EC46635F5073C4F4882FFFC \
  1D70CBE4B42239445617D33DD316C8140185B647 \
  1D5889CB9E0564C154E18BB512EC9519DB43CC27 >/dev/null 2>&1

echo "[*] Verifying signatures..."
if gpg --verify SHA256SUMS.asc SHA256SUMS >/dev/null 2>&1; then
  echo "[OK] Signatures verified successfully."
else
  echo "[WARN] Signature check incomplete (some keys may be missing, but known signers verified)."
fi

echo "[*] Verifying checksums..."
grep "\$ARCHIVE" SHA256SUMS | sha256sum -c -

echo "[*] Extracting binaries..."
tar -xzf "\$ARCHIVE" --strip-components=1

echo "[*] Setting up regtest environment..."
cat > "\$DATA_DIR/bitcoin.conf" <<EOF
regtest=1
fallbackfee=0.0001
server=1
txindex=1
EOF

echo "[*] Starting bitcoind in regtest mode..."
./bin/bitcoind -datadir="\$DATA_DIR" -daemon
sleep 3

# ✅ Wait for RPC to be ready
echo "[*] Waiting for bitcoind RPC to be ready..."
for i in {1..20}; do
  if ./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwait getblockchaininfo >/dev/null 2>&1; then
    echo "[OK] bitcoind RPC is ready."
    break
  else
    sleep 1
  fi
  if [ \$i -eq 20 ]; then
    echo "[ERROR] bitcoind did not respond in time."
    exit 1
  fi
done

echo "[*] Creating wallets Miner and Trader..."
./bin/bitcoin-cli -datadir="\$DATA_DIR" createwallet Miner
./bin/bitcoin-cli -datadir="\$DATA_DIR" createwallet Trader

echo "[*] Generating new addresses..."
miner_address=\$(./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Miner getnewaddress)
trader_address=\$(./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Trader getnewaddress)

echo "[*] Mining 103 blocks to fund Miner..."
./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Miner generatetoaddress 103 "\$miner_address" >/dev/null

echo "[*] Sending 1 BTC from Miner to Trader..."
txid=\$(./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Miner sendtoaddress "\$trader_address" 1)

echo "[*] Confirming transaction..."
./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Miner generatetoaddress 1 "\$miner_address" >/dev/null

echo "[*] Fetching transaction details..."
transaction_info=\$(./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Miner gettransaction "\$txid")
amount=\$(echo "\$transaction_info" | jq '.amount')
blockheight=\$(echo "\$transaction_info" | jq '.blockheight')
fee=\$(echo "\$transaction_info" | jq '.fee')

miner_balance=\$(./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Miner getbalance)
trader_balance=\$(./bin/bitcoin-cli -datadir="\$DATA_DIR" -rpcwallet=Trader getbalance)

echo "---------------------------------------"
echo "Transaction ID: \$txid"
echo "From: \$miner_address"
echo "To:   \$trader_address"
echo "Amount: \${amount} BTC"
echo "Fee: \${fee} BTC"
echo "Block Height: \${blockheight}"
echo "Miner Balance: \${miner_balance} BTC"
echo "Trader Balance: \${trader_balance} BTC"
echo "---------------------------------------"

{
echo "Transaction ID: \$txid"
echo "From: \$miner_address"
echo "To: \$trader_address"
echo "Amount: \$amount"
echo "Fee: \$fee"
echo "Block Height: \$blockheight"
echo "Miner Balance: \$miner_balance"
echo "Trader Balance: \$trader_balance"
} > "\$OUT_FILE"

echo "[*] Stopping Bitcoin Knots..."
./bin/bitcoin-cli -datadir="\$DATA_DIR" stop >/dev/null
sleep 3

echo "[*] Cleaning up..."
rm -rf "\$DATA_DIR"

echo "[DONE] Regtest complete! Transaction details saved to: \${OUT_FILE}"
`;

  const contentRef = useRef(null);
  const titleText = "Set-Up Your Regtest Bitcoin Node (Hands-On)";
  const links = {
    prev: "/bitcoin-tech-page-77",
    index: "/index-bitcoin-tech",
    next: "/bitcoin-tech-page-79",
  };
  const questions = [
    {
      text: "1. What is the primary purpose of running Bitcoin in regtest mode?",
      options: [
        { value: "A", label: "A. To mine real bitcoins faster" },
        {
          value: "B",
          label:
            "B. To test and experiment with a private blockchain without using real coins",
        },
        { value: "C", label: "C. To connect directly to the Bitcoin mainnet" },
        { value: "D", label: "D. To compete with other miners on testnet" },
      ],
      correct: "B",
    },
    {
      text: "2. In the provided regtest setup, why are two wallets created (Miner and Trader)?",
      options: [
        {
          value: "A",
          label:
            "A. To simulate mining and transaction activity between participants",
        },
        { value: "B", label: "B. To earn interest on mined bitcoins" },
        { value: "C", label: "C. To connect to multiple Bitcoin networks" },
        { value: "D", label: "D. To verify SHA256SUMS signatures" },
      ],
      correct: "A",
    },
    {
      text: "3. How does the script ensure the downloaded Bitcoin binaries are authentic?",
      options: [
        { value: "A", label: "A. By checking file sizes" },
        {
          value: "B",
          label: "B. By verifying digital signatures and SHA256 checksums",
        },
        {
          value: "C",
          label: "C. By connecting to the mainnet and comparing versions",
        },
        { value: "D", label: "D. By running test transactions first" },
      ],
      correct: "B",
    },

    {
      text: "4. What does mining 103 blocks in this regtest setup accomplish?",
      options: [
        { value: "A", label: "A. It validates transactions on mainnet" },
        {
          value: "B",
          label: "B. It generates spendable coins for the Miner wallet",
        },
        { value: "C", label: "C. It increases network difficulty globally" },
        { value: "D", label: "D. It updates the Bitcoin  software" },
      ],
      correct: "B",
    },
  ];

  // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);

  return (
    <div className="container">
      <LandingSection
        titleText={titleText}
        scrollToRef={contentRef}
        progressValue={78}
        timerMinutes={90}
        currentLevel={6}
        unlockedBadges={11}
      />
      <p className="content" ref={contentRef}>
        Welcome to <b>Day 78</b>! Today, we are going to take a major step
        forward in your journey of understanding Bitcoin technology by running
        your very own Bitcoin node in regtest mode. This exercise will give you
        hands-on experience with how a Bitcoin node operates internally,
        including how it mines blocks, creates wallets, sends transactions, and
        interacts with the blockchain, all in a completely private and
        controlled environment.
        <br />
        Regtest, short for Regression Testing mode, is a special mode of
        operation designed for developers and learners. Unlike Bitcoin’s main
        network (mainnet) or testnet, regtest allows you to create your own
        local Bitcoin blockchain where you can instantly mine blocks, generate
        transactions, and test ideas freely, without requiring internet access
        or real bitcoins. It is fast, private, and perfectly suited for
        experimentation.
        <br />
        One of the greatest advantages of regtest mode is that it runs
        efficiently even on resource-constrained devices such as older laptops
        or small development boards like the Raspberry Pi. It does not need to
        connect to the network, uses very little processing power, and stores
        only the blocks you create. This makes regtest ideal for educational and
        research purposes, as it allows you to safely explore the Bitcoin system
        without risking real funds or affecting the live network. <br />
        By the end of this lesson, you will learn how to automate the process of
        setting up a Bitcoin node regtest environment using a simple shell
        script. You will see how to start the Bitcoin daemon, create wallets,
        mine blocks, send and confirm transactions, and extract details such as
        transaction IDs and balances, all from your own computer.
        <br /> Once you master these concepts in regtest, you will have the
        foundational skills to move to testnet or even mainnet, where your node
        will connect to the global Bitcoin network and verify real transactions.
        In short, today’s exercise will help you gain both technical
        understanding and practical confidence to interact directly with the
        Bitcoin protocol as a user, developer, or researcher.
      </p>
      <>
        <p className="content">
          <b>Setting Up and Using a Bitcoin Node in Regtest Mode</b>
          <br />
          <br />
          This script sets up and runs a complete Bitcoin node regtest
          environment on your system. Regtest (Regression Test Mode) is a
          special mode where you can create a local Bitcoin network, mine blocks
          instantly, and test transactions without using real coins. It is an
          ideal learning environment that can run even on resource-constrained
          devices like laptops or Raspberry Pis.
          <br />
          <br />
          The goal of this task is to help learners set up and interact with a
          Bitcoin node in regtest mode, a private Bitcoin network used for
          testing and education. In this exercise, you will configure a
          lightweight local blockchain environment, create two wallets named
          Miner and Trader, and simulate real Bitcoin operations without using
          actual coins or connecting to the internet. You will mine blocks to
          generate test bitcoins, send a transaction from the Miner wallet to
          the Trader wallet, and confirm it by mining another block. By the end
          of this task, you will have learned how to run a node, manage wallets,
          perform transactions, and analyze blockchain data in a fully
          controlled and safe environment.
          <br />
          We will first go through the script and understand it, before we
          execute it in our local systems.
          <br />
          <br />
          <b>Uderstanding the bash script</b>
        </p>
        <p className="content">
          <br /> The script first defines key variables such as the version
          number, download URLs, and data directories.
        </p>
        <p className="code-block">
          VERSION="29.2.knots20251110"
          <br />
          BASE_URL="https://bitcoinknots.org/files/29.x/$'{"VERSION"}'"
          <br />
          ARCHIVE="bitcoin-$'{"VERSION"}'-x86_64-linux-gnu.tar.gz"
          <br />
          BITCOIN_DIR="$HOME/bitcoin-knots"
          <br />
          DATA_DIR="$HOME/tmp/regtest_bitcoin"
          <br />
          OUT_FILE="out.txt"
        </p>
        <p className="content">
          It then prepares the environment by updating system packages,
          installing dependencies, and creating necessary directories for
          storing binaries and blockchain data.
        </p>
        <p className="code-block">
          sudo apt-get update -y
          <br />
          sudo apt-get install -y wget gpg jq bc
          <br />
          mkdir -p "$BITCOIN_DIR" "$DATA_DIR"
          <br />
          cd "$BITCOIN_DIR"
        </p>
        <p className="content">
          Next, the script downloads the Bitcoin Client binaries, checksum
          files, and signature files directly from the official Bitcoin Knots
          website to ensure authenticity.
        </p>
        <p className="code-block">
          wget -q "$'{"BASE_URL"}'/$'{"ARCHIVE"}'"
          <br />
          wget -q "$'{"BASE_URL"}'/SHA256SUMS"
          <br />
          wget -q "$'{"BASE_URL"}'/SHA256SUMS.asc"
        </p>
        <p className="content">
          It imports the recommended developer signing keys using GPG, then
          verifies both the digital signatures and SHA256 checksums to make sure
          the downloaded binaries have not been tampered with.
        </p>
        <p className="code-block">
          gpg --keyserver hkps://keys.openpgp.org --recv-keys ...
          <br />
          gpg --verify SHA256SUMS.asc SHA256SUMS
          <br />
          grep "$ARCHIVE" SHA256SUMS | sha256sum -c -
        </p>
        <p className="content">
          Once verified, it extracts the binaries and sets up a minimal
          configuration file for running Bitcoin client in regtest mode with
          parameters like `server=1` and `txindex=1`.
        </p>
        <p className="code-block">
          cat &gt; "$DATA_DIR/bitcoin.conf" &lt;&lt;EOF
          <br />
          regtest=1
          <br />
          fallbackfee=0.0001
          <br />
          server=1
          <br />
          txindex=1
          <br />
          EOF
        </p>
        <p className="content">
          The node is then started in the background, and the script patiently
          waits until the RPC (Remote Procedure Call) interface becomes
          available. This ensures that commands sent to Bitcoin client will
          execute correctly.
        </p>
        <p className="code-block">
          ./bin/bitcoind -datadir="$DATA_DIR" -daemon
          <br />
          ./bin/bitcoin-cli -datadir="$DATA_DIR" -rpcwait getblockchaininfo
        </p>
        <p className="content">
          After the node is ready, it creates two wallets: Miner and Trader.
          These wallets are used to simulate transactions in your local
          blockchain.
        </p>
        <p className="code-block">
          ./bin/bitcoin-cli -datadir="$DATA_DIR" createwallet Miner
          <br />
          ./bin/bitcoin-cli -datadir="$DATA_DIR" createwallet Trader
        </p>
        <p className="content">
          The Miner wallet generates a new address, mines 103 blocks, and
          receives block rewards to fund its balance. Then, it sends 1 BTC to
          the Trader wallet and mines one more block to confirm the transaction.
        </p>
        <p className="code-block">
          ./bin/bitcoin-cli -rpcwallet=Miner generatetoaddress 103
          "$miner_address"
          <br />
          ./bin/bitcoin-cli -rpcwallet=Miner sendtoaddress "$trader_address" 1
          <br />
          ./bin/bitcoin-cli -rpcwallet=Miner generatetoaddress 1
          "$miner_address"
        </p>
        <p className="content">
          The script then retrieves transaction details such as transaction ID,
          amount, fee, and block height using the Bitcoin Client command-line
          interface.
        </p>
        <p className="code-block">
          transaction_info=$(./bin/bitcoin-cli gettransaction "$txid")
          <br />
          amount=$(echo "$transaction_info" | jq '.amount')
          <br />
          fee=$(echo "$transaction_info" | jq '.fee')
        </p>
        <p className="content">
          Finally, it writes all the important details into an{" "}
          <code>out.txt</code> file for record-keeping and gracefully stops the
          Bitcoin Client daemon. It also cleans up the temporary data directory
          to keep your system tidy.
        </p>
        <p className="code-block">
          ./bin/bitcoin-cli stop
          <br />
          rm -rf "$DATA_DIR"
        </p>
        <p className="content">
          By running this script, we gain hands-on experience in operating a
          Bitcoin node, understanding the workflow of wallet creation, mining,
          transaction broadcasting, and chain management, all within a
          completely private blockchain environment.
          <br />
          <br />
          Now that we understood the task and the working of the script we are
          ready to execute it in pur local environment.
          <ul>
            <li>
              Open your computer's terminal/shell and go to the directory where
              you intend to run the node (assuming root directory)
            </li>
          </ul>
        </p>
        <p className="code-block">cd ~</p>
        <p className="content">
          <ul>
            <li>
              make sure no other bitcoin clients are running in the background
            </li>
          </ul>
        </p>
        <p className="code-block">pgrep -a bitcoind</p>
        <p className="content">
          If it prints nothing, no daemon is running.
          <br />
          If it prints a line like this:
        </p>
        <p className="code-block">
          2948 /home/usern_name/tmp/regtest_bitcoin/bitcoin-knots/bin/bitcoind
          -regtest ...
        </p>
        <p className="content">
          that’s the process ID and its command line (4 digit number at the
          start might vary). <br />
          To stop it:
        </p>
        <p className="code-block">kill 2948</p>
        <p className="content">
          <ul>
            <li>create a bash file </li>
          </ul>
        </p>
        <p className="code-block">nano run_bitcoin_regtest.sh</p>
        <p className="content">
          <ul>
            <li>
              Then copy and paste the{" "}
              <span
                style={{
                  color: "blue",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  const section = document.getElementById("script");
                  if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                below script
              </span>{" "}
              and save it (Ctrl + O -{">"} Enter -{">"} Ctrl + X){" "}
            </li>
          </ul>
          <ul>
            {" "}
            <li>make the below shared script executable</li>
          </ul>
        </p>
        <p className="code-block">chmod +x run_bitcoin_regtest.sh</p>
        <p className="content">
          <ul>
            <li>run the script</li>
          </ul>
        </p>
        <p className="code-block">/run_bitcoin_regtest.sh</p>
      </>
      <h2>Regtest Automation Script (for Linux)</h2>
      <div className="code-block" id="script">
        <pre>{run_bitcoin_regtest}</pre>
        <button
          className="copy-button"
          onClick={() => {
            navigator.clipboard.writeText(run_bitcoin_regtest);
            alert("Copied to clipboard!");
          }}
        >
          Copy to Clipboard
        </button>
      </div>
      <p className="content">
        <b>Summary of Today’s Lesson:</b>
        <br />
        <br />
        In this lesson, we explored how to set up and run a Bitcoin node in
        regtest mode, a private, local blockchain environment ideal for
        experimentation and education. By running the provided script, users
        downloaded verified Bitcoin client binaries, started a local daemon,
        created two wallets (“Miner” and “Trader”), mined blocks to generate
        spendable coins, and sent a transaction between the wallets. This
        exercise demonstrates how the Bitcoin system functions end-to-end, from
        block creation to transaction confirmation, without requiring any
        internet connection or real bitcoins. Through this setup, we gain
        hands-on experience with how a Bitcoin node operates and build a solid
        foundation for later running a node on testnet or mainnet.
      </p>
      <h2>Test your understanding</h2>
      {questions.map((q, index) => (
        <Question
          key={index}
          questionText={q.text}
          options={q.options}
          correctAnswer={q.correct}
          onAnswer={(value) => handleAnswerChange(index, value)}
        />
      ))}

      <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
        Score: {score} / {questions.length}
      </div>

      <FloatingPageNav
        prevLink={links.prev}
        indexLink={links.index}
        nextLink={links.next}
      />
    </div>
  );
}

export default BitcoinTechPage78;
